import styled from "styled-components";

interface IButtonLabelProps {
    fontSize: number;
}

export const ButtonLabelDefaultBox = styled.span<IButtonLabelProps>`
    text-transform: uppercase;
    font-size: ${({fontSize}) => fontSize}em;

    /** If the label is not perfectly vertical centered please DO NOT modify this line-height use padding-top or padding-bottom in specific skin components */
    line-height: 1.2;
    /********* */
    max-height: 2.2em;
`;